import { render } from "./MoolngFooter.vue?vue&type=template&id=38d65140&scoped=true"
import script from "./MoolngFooter.vue?vue&type=script&lang=js"
export * from "./MoolngFooter.vue?vue&type=script&lang=js"

import "./MoolngFooter.vue?vue&type=style&index=0&id=38d65140&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d65140"]])

export default __exports__